import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import KanbanBoard from '../components/kanban.tsx';
import ChatPage from '../pages/chat_page.tsx';
import { JobToResumes } from '../pages/JobToResumes.tsx';
import { AdJD } from '../pages/add_jd.tsx';
import { useRecruiter } from '../context/RecruiterContext.tsx';
import { HistoricalSearch } from '../pages/HistoricalSearch.tsx';
import JDSetup from './jobdescription/jdsetup.tsx';
interface RecruiterDashboardProps {
    isRecruiter: any;
}

const RecruiterDashboard: React.FC<RecruiterDashboardProps> = ({ isRecruiter }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const recruiter = useRecruiter();
    const [activeTab, setActiveTab] = useState('kanban');
    const [modalMessage, setModalMessage] = useState<string | null>(null);

    useEffect(() => {
        if (!isRecruiter.isRecruiter) {
            const message = 'You are not authorized to view this page. If you are a recruiter contact us on support@cvseeyou.com to get started today!';
            const encodedMessage = btoa(message);
            navigate('/?message=' + encodedMessage);
        }

        const params = new URLSearchParams(location.search);
        const message = params.get('message');
        if (message) {
            setModalMessage(atob(message));
        }
    }, [isRecruiter, navigate, location]);

    const closeModal = () => {
        setModalMessage(null);
    };

    const renderContent = (recruiter) => {
        switch (activeTab) {
            case 'kanban':
                return <KanbanBoard />;
            case 'chat':
                return <ChatPage />;
            case 'search':
                return <JobToResumes isLoggedIn={recruiter.isLoggedIn} />;
            case 'add_jd':
                return <AdJD isLoggedIn={recruiter.isLoggedIn} />;
            case 'historical':
                return <HistoricalSearch isLoggedIn={recruiter.isLoggedIn} />
            case 'jdSetup':
                return <JDSetup isLoggedIn={true} />
            default:
                return <KanbanBoard />;
        }
    };

    return (
        <div className="flex flex-col h-screen">
            <nav className="bg-gray-800 text-white p-4">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="flex space-x-4">
                        <button
                            className={`px-3 py-2 rounded ${activeTab === 'kanban' ? 'bg-blue-500' : 'bg-gray-700'}`}
                            onClick={() => setActiveTab('kanban')}
                        >
                            Kanban
                        </button>
                        <button
                            className={`px-3 py-2 rounded ${activeTab === 'chat' ? 'bg-blue-500' : 'bg-gray-700'}`}
                            onClick={() => setActiveTab('chat')}
                        >
                            Chat
                        </button>
                        <button
                            className={`px-3 py-2 rounded ${activeTab === 'add_jd' ? 'bg-blue-500' : 'bg-gray-700'}`}
                            onClick={() => setActiveTab('add_jd')}
                        >
                            Add Job Description
                        </button>
                        <button
                            className={`px-3 py-2 rounded ${activeTab === 'search' ? 'bg-blue-500' : 'bg-gray-700'}`}
                            onClick={() => setActiveTab('search')}
                        >
                            Search
                        </button>
                        <button
                            className={`px-3 py-2 rounded ${activeTab === 'historical' ? 'bg-blue-500' : 'bg-gray-700'}`}
                            onClick={() => setActiveTab('historical')}
                        >
                            Historical Search
                        </button>
                        <button
                            className={`px-3 py-2 rounded ${activeTab === 'jdSetup' ? 'bg-blue-500' : 'bg-gray-700'}`}
                            onClick={() => setActiveTab('jdSetup')}
                        >
                            Create Job Description
                        </button>

                    </div>
                </div>
            </nav>
            <div className="flex-grow p-4">
                {renderContent(recruiter)}
            </div>
            {modalMessage && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                        <h2 className="text-2xl font-bold mb-4">Message</h2>
                        <p>{modalMessage}</p>
                        <button
                            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            onClick={closeModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RecruiterDashboard;